module.exports = ".player-adjustment-caption {\r\n  display: contents;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/member-billing-info/scholarship-information/scholarship-information.component.css
// module id = ./src/app/shared/components/member-billing-info/scholarship-information/scholarship-information.component.css
// module chunks = main